module.exports = __webpack_public_path__ + "img/site-jlo-side.01e006d1.png";